module.exports = __webpack_public_path__ + "img/btn4-370x300.5920686d.jpg";